import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "menu"];

    toggle() {
        const menu = this.menuTarget;
        const button = this.buttonTarget;

        menu.classList.toggle('opened');
    }
}